
export const localValidate = (formState) => {
  let errors = {};

  if (formState.username.trim() === '') {
    errors.username = 'Username is required';
  }

  return errors;
};

const ForgotPasswordFormValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default ForgotPasswordFormValidation;